import '../styles/globals.css'
import type { AppProps } from 'next/app'
import Head from 'next/head'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { Inter, Plus_Jakarta_Sans } from 'next/font/google'
import theme from '../src/theme'

const inter = Inter({ subsets: ['latin'], variable: '--font-inter' })
const plusJakarta = Plus_Jakarta_Sans({
  subsets: ['latin'],
  weight: ['400', '500', '600', '700', '800'],
  variable: '--font-plus-jakarta',
})

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Head>
        <link rel="icon" type="image/svg+xml" href="/holmiapp-mark.svg" />
        <link rel="apple-touch-icon" href="/holmiapp-mark.svg" />
        <meta name="viewport" content="minimum-scale=1,initial-scale=1,width=device-width" />
      </Head>
      <main className={`${inter.className} ${plusJakarta.className}`}>
        <Component {...pageProps} />
      </main>
    </ThemeProvider>
  )
}

export default MyApp
